import { SpinnerYellowIcon, DeniedRedIcon, InfoPurpleIcon, ApprovedGreenIcon } from 'assets';
import * as S from './styled';

const getStatusClass = (status: any) => {
  switch (status) {
    case 'Applied':
      return 'yellow';
    case 'Pending':
      return 'yellow';
    case 'No Longer In Consideration':
      return 'red';
    case 'Denied':
      return 'red';
    case 'New':
      return 'purple';
    case 'Approved':
      return 'green';
    default:
      return '';
  }
};

const getStatusIcon = (status: any) => {
  switch (status) {
    case 'Applied':
      return <SpinnerYellowIcon />;
    case 'Pending':
      return <SpinnerYellowIcon />;
    case 'No Longer In Consideration':
      return <DeniedRedIcon />;
    case 'Denied':
      return <DeniedRedIcon />;
    case 'New':
      return <InfoPurpleIcon />;
    case 'Approved':
      return <ApprovedGreenIcon />;
    default:
      return null;
  }
};

const StatusBlock = ({ appStatus }) => {
  return (
    <>
      {appStatus === 'No status' ? null : (
        <S.StatusBlock className={getStatusClass(appStatus)}>
          {getStatusIcon(appStatus)}
          <p>{appStatus}</p>
        </S.StatusBlock>
      )}
    </>
  );
};

export default StatusBlock;
